let Module = {
    name: 'loadSaveForm',
    selectors: {
        saveCookieClass: '.saveCookie',
        loadCookieClass: '.loadCookie'
    },
    options: {
        saveCookieName: 'subscriptionContactForm'
    },

    init: function () {
        Module.loadFormDataCookie();
        $(document).on('change, change.select2', Module.selectors.saveCookieClass, function() {
            Module.setCookie(JSON.stringify($(Module.selectors.saveCookieClass).serializeArray()), 1);
        });
    },

    loadFormDataCookie() {
        let formFields = Module.getCookie();
        if (formFields === null) {
            return;
        }
        let formField = $.parseJSON(formFields);
        $(Module.selectors.loadCookieClass).each(function() {
            let input = $(this);
            $(formField).each(function() {
                if (input.attr('name') !== this.name) {
                    return;
                }
                if (this.value === 'on') {
                    input.attr('checked', true);
                } else {
                    input.val(this.value);
                    input.trigger('change');
                }
            });
        });
    },

    setCookie(value, days) {
        let expires = "";

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = Module.options.saveCookieName + "=" + (value || "")  + expires + "; path=/";
    },

    getCookie() {
        let matches = document.cookie.match(new RegExp( "(?:^|; )" + Module.options.saveCookieName.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)" ));
        return matches ? matches[1] : null;
    },
}

module.exports = Module
